import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/pro-light-svg-icons/faCheck";

class Checkbox extends Component {

    static propTypes = {
        label: PropTypes.string,
        forceValidation: PropTypes.bool
    }

    handleCheckboxClick = (e) => {
        e.preventDefault();
        this.props.input.onChange(!this.props.input.checked)
    }

    render() {

        let className = this.props.className ? this.props.className : ''

        className += " checkbox"

        if (this.props.input.checked) {
            className += " checkbox--checked"
        }

        if (this.props.meta.error && (this.props.meta.touched || this.props.meta.visited || this.props.forceValidation)) {
            className += " checkbox--error"
        }

        return (
            <div className={"checkbox-wrapper" + ( this.props.input.checked ? ' checkbox-wrapper--checked' : '')} onClick={this.handleCheckboxClick}>
                <input type="checkbox" className={className} onClick={this.handleCheckboxClick}/>
                <FontAwesomeIcon icon={faCheck}/>
                <span>{this.props.label}</span>
            </div>
        )
    }

}

export default Checkbox



/** WEBPACK FOOTER **
 ** ./src/components/Checkbox.js
 **/